import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { streamActions } from '../../../../store/modules/stream';

const useDeleteRecordingModal = (streamId: string) => {
  const dispatch = useDispatch();

  const handelDeleteRecording = useCallback(() => {
    dispatch(streamActions.deleteRecording(streamId));
  }, [streamId]);

  return handelDeleteRecording;
};

export default useDeleteRecordingModal;
